const treatmentPages = {
  "homeopathy-for-psoriasis": {
    slug: "homeopathy-for-psoriasis",
    url: "/homeopathy-for-psoriasis",
    disease: "Psoriasis",
    keyword: "homeopathy for psoriasis",
    category: "skin",
    remedies: ["Sulphur", "Graphites", "Arsenicum Album"],
    whatIs:
      "Psoriasis is a chronic inflammatory skin condition in which skin cells multiply faster than normal, leading to thick, scaly, itchy, or cracked patches. It can wax and wane, often worsening with stress, weather changes, infections, or lifestyle triggers.",
    symptoms: [
      "Red, inflamed patches covered with silvery-white scales",
      "Itching, burning, or stinging sensation over lesions",
      "Dry skin with cracking, occasional bleeding, or soreness",
      "Scalp scaling with dandruff-like flakes and irritation",
      "Nail pitting, discoloration, or brittle nails in some cases",
      "Joint stiffness in associated psoriatic arthritis cases",
    ],
    causes: [
      "Immune system overactivity and inflammatory response",
      "Family history and genetic susceptibility",
      "Stress, poor sleep, and emotional triggers",
      "Winter weather, skin trauma, or recurrent infections",
      "Smoking, alcohol use, obesity, and dietary imbalance",
    ],
    related: ["homeopathy-for-eczema", "homeopathy-for-vitiligo", "homeopathy-for-acne", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-eczema": {
    slug: "homeopathy-for-eczema",
    url: "/homeopathy-for-eczema",
    disease: "Eczema",
    keyword: "homeopathy for eczema",
    category: "skin",
    remedies: ["Graphites", "Sulphur", "Petroleum"],
    whatIs:
      "Eczema (atopic dermatitis) is a recurrent inflammatory skin disorder that causes intense itching, dryness, redness, and skin barrier weakness. It often appears in childhood but may persist or begin in adulthood and can be associated with allergy tendencies.",
    symptoms: [
      "Severe itching, often worse at night",
      "Dry, rough, or thickened skin patches",
      "Redness, inflammation, and oozing during flare-ups",
      "Crusting or scaling in chronic lesions",
      "Skin sensitivity to soaps, detergents, or climate",
      "Sleep disturbance due to persistent itching",
    ],
    causes: [
      "Skin barrier dysfunction and moisture loss",
      "Allergic tendency and immune dysregulation",
      "Family history of eczema, asthma, or rhinitis",
      "Irritants such as fragrances, wool, or chemicals",
      "Stress, heat, sweating, and weather fluctuations",
    ],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-vitiligo", "homeopathy-for-acne", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-vitiligo": {
    slug: "homeopathy-for-vitiligo",
    url: "/homeopathy-for-vitiligo",
    disease: "Vitiligo",
    keyword: "homeopathy for vitiligo",
    category: "skin",
    remedies: ["Arsenicum Sulphuratum Flavum", "Sepia", "Natrum Muriaticum"],
    whatIs:
      "Vitiligo is a pigmentary condition where melanocyte function is reduced or lost, resulting in white depigmented patches on skin. The condition is medically benign but can create significant psychological and social impact due to visible skin changes.",
    symptoms: [
      "Milky-white patches with clear or irregular borders",
      "Patch enlargement over time in some patients",
      "Hair whitening over affected skin areas",
      "Symmetrical distribution in many cases",
      "Photosensitivity over depigmented areas",
      "Emotional stress due to cosmetic concerns",
    ],
    causes: [
      "Autoimmune and inflammatory mechanisms",
      "Genetic predisposition and family tendency",
      "Associated endocrine or thyroid imbalance",
      "Stress and oxidative skin injury",
      "Koebner phenomenon after trauma in predisposed skin",
    ],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-eczema", "homeopathy-for-acne", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-acne": {
    slug: "homeopathy-for-acne",
    url: "/homeopathy-for-acne",
    disease: "Acne",
    keyword: "homeopathy for acne",
    category: "skin",
    remedies: ["Hepar Sulph", "Kali Bromatum", "Silicea"],
    whatIs:
      "Acne is a common inflammatory disorder of pilosebaceous units, frequently seen on the face, chest, and back. It is influenced by hormones, sebum production, bacterial activity, and inflammation and may lead to post-acne marks and scars.",
    symptoms: [
      "Blackheads and whiteheads",
      "Inflamed papules and pustules",
      "Painful nodules in moderate to severe acne",
      "Oily skin and clogged pores",
      "Post-inflammatory marks and uneven texture",
      "Acne-related low confidence and social stress",
    ],
    causes: [
      "Hormonal fluctuations and androgen sensitivity",
      "Excess sebum and pore blockage",
      "Inflammatory reaction and skin microbiome shifts",
      "High stress, irregular sleep, and dietary triggers",
      "Cosmetic products or environmental pollution",
    ],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-eczema", "homeopathy-for-vitiligo", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-urticaria": {
    slug: "homeopathy-for-urticaria",
    url: "/homeopathy-for-urticaria",
    disease: "Urticaria",
    keyword: "homeopathy for urticaria",
    category: "skin",
    remedies: ["Apis Mellifica", "Urtica Urens", "Natrum Mur"],
    whatIs:
      "Urticaria (hives) is a skin reaction characterized by itchy, raised wheals that may appear suddenly and shift from one area to another. Episodes can be acute or chronic and are often linked to allergic, immune, temperature, or stress-related triggers.",
    symptoms: [
      "Raised, itchy, red or skin-colored wheals",
      "Burning or prickling sensation in affected areas",
      "Rapid appearance and disappearance of rashes",
      "Swelling of lips or eyelids in some episodes",
      "Worsening after heat, pressure, or certain foods",
      "Sleep disturbance due to intense itching",
    ],
    causes: [
      "Allergic triggers from food, drugs, or additives",
      "Viral infections or immune reactivity",
      "Heat, cold, pressure, and environmental factors",
      "Stress-related neuroimmune activation",
      "Idiopathic causes in chronic urticaria cases",
    ],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-eczema", "homeopathy-for-vitiligo", "homeopathy-for-acne"],
  },
  "homeopathy-for-hair-fall": {
    slug: "homeopathy-for-hair-fall",
    url: "/homeopathy-for-hair-fall",
    disease: "Hair Fall",
    keyword: "homeopathy for hair fall",
    category: "hair",
    remedies: ["Phosphorus", "Natrum Mur", "Lycopodium"],
    whatIs:
      "Hair fall is a common concern that may arise from nutritional deficiency, stress, hormonal factors, thyroid dysfunction, postpartum changes, or scalp disorders. Persistent shedding can affect confidence and is best managed through early assessment.",
    symptoms: ["Excess hair on pillow, comb, or shower drain", "Visible thinning over scalp or parting line", "Reduced hair density and weak strands", "Seasonal worsening or stress-linked shedding", "Dry scalp or associated dandruff"],
    causes: ["Nutritional deficiencies (iron, protein, vitamin D)", "Thyroid or hormonal imbalance", "Stress, sleep deprivation, and lifestyle strain", "Scalp inflammation and dandruff", "Hereditary tendency"],
    related: ["homeopathy-for-alopecia", "homeopathy-for-dandruff", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-alopecia": {
    slug: "homeopathy-for-alopecia",
    url: "/homeopathy-for-alopecia",
    disease: "Alopecia",
    keyword: "homeopathy for alopecia",
    category: "hair",
    remedies: ["Fluoric Acid", "Natrum Mur", "Silicea"],
    whatIs:
      "Alopecia refers to patchy or generalized hair loss due to autoimmune, hormonal, nutritional, stress-related, or hereditary factors. Early diagnosis helps differentiate temporary shedding from progressive follicular damage and improves long-term outcomes.",
    symptoms: ["Round or patchy bald spots", "Sudden increase in shedding", "Loss of eyebrows or beard hair in some cases", "Brittle, fragile hair shafts", "Scalp sensitivity or associated inflammation"],
    causes: ["Autoimmune mechanism in alopecia areata", "Family history of pattern hair loss", "Stress and immune dysregulation", "Nutritional imbalance or thyroid dysfunction", "Post-illness or medication-related shedding"],
    related: ["homeopathy-for-hair-fall", "homeopathy-for-dandruff", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-dandruff": {
    slug: "homeopathy-for-dandruff",
    url: "/homeopathy-for-dandruff",
    disease: "Dandruff",
    keyword: "homeopathy for dandruff",
    category: "hair",
    remedies: ["Kali Sulph", "Natrum Mur", "Sulphur"],
    whatIs:
      "Dandruff is a chronic scalp condition involving flaking, itching, and irritation, often linked with seborrheic tendencies, fungal overgrowth, stress, and poor scalp hygiene practices. Recurrent dandruff can contribute to discomfort and hair fall.",
    symptoms: ["Visible white or yellow scalp flakes", "Scalp itching and irritation", "Greasy or dry scaling patches", "Mild scalp redness", "Flare-ups in winter or stress periods"],
    causes: ["Seborrheic scalp activity", "Malassezia-related scalp imbalance", "Irregular cleansing routines", "Stress and sleep disturbance", "Use of unsuitable hair products"],
    related: ["homeopathy-for-hair-fall", "homeopathy-for-alopecia", "homeopathy-for-acne"],
  },
  "homeopathy-for-sinusitis": {
    slug: "homeopathy-for-sinusitis",
    url: "/homeopathy-for-sinusitis",
    disease: "Sinusitis",
    keyword: "homeopathy for sinusitis",
    category: "respiratory",
    remedies: ["Kali Bichromicum", "Pulsatilla", "Silicea"],
    whatIs:
      "Sinusitis is inflammation of the sinus lining causing facial pressure, blocked nose, thick discharge, and headache. It may be acute after infection or chronic with allergy, structural, or immune factors and can affect concentration and sleep.",
    symptoms: ["Nasal blockage and postnasal drip", "Facial pain or heaviness", "Headache worse on bending forward", "Thick yellow or green discharge", "Reduced smell and fatigue"],
    causes: ["Recurrent upper respiratory infections", "Allergic inflammation", "Dust and pollution exposure", "Nasal structural issues", "Low immunity and chronic inflammation"],
    related: ["homeopathy-for-asthma", "homeopathy-for-allergic-rhinitis", "homeopathy-for-migraine"],
  },
  "homeopathy-for-allergic-rhinitis": {
    slug: "homeopathy-for-allergic-rhinitis",
    url: "/homeopathy-for-allergic-rhinitis",
    disease: "Allergic Rhinitis",
    keyword: "homeopathy for allergic rhinitis",
    category: "respiratory",
    remedies: ["Allium Cepa", "Arsenicum Album", "Sabadilla"],
    whatIs:
      "Allergic rhinitis is an immune-mediated reaction of the nasal mucosa to allergens like dust mites, pollen, mold, or pet dander. It causes sneezing, watery discharge, blockage, and eye irritation and can become recurrent across seasons.",
    symptoms: ["Repeated sneezing spells", "Watery nasal discharge", "Nasal blockage and mouth breathing", "Itchy nose, throat, and eyes", "Daytime fatigue due to poor sleep"],
    causes: ["Allergen exposure (dust, pollen, mites)", "Hyperreactive immune response", "Family history of atopy", "Weather and seasonal shifts", "Indoor pollution and irritants"],
    related: ["homeopathy-for-sinusitis", "homeopathy-for-asthma", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-asthma": {
    slug: "homeopathy-for-asthma",
    url: "/homeopathy-for-asthma",
    disease: "Asthma",
    keyword: "homeopathy for asthma",
    category: "respiratory",
    remedies: ["Arsenicum Album", "Spongia Tosta", "Ipecacuanha"],
    whatIs:
      "Asthma is a chronic airway inflammatory condition causing recurrent wheezing, breathlessness, chest tightness, and cough. Symptoms may worsen with allergens, infection, exertion, or weather changes and require long-term, monitored care.",
    symptoms: ["Wheezing and shortness of breath", "Night cough or early morning cough", "Chest tightness and breathing discomfort", "Trigger-based breathing episodes", "Exercise intolerance in active phases"],
    causes: ["Allergic airway inflammation", "Genetic predisposition", "Dust, smoke, and pollution exposure", "Respiratory infections", "Stress and weather changes"],
    related: ["homeopathy-for-sinusitis", "homeopathy-for-allergic-rhinitis", "homeopathy-for-anxiety"],
  },
  "homeopathy-for-pcos": {
    slug: "homeopathy-for-pcos",
    url: "/homeopathy-for-pcos",
    disease: "PCOS",
    keyword: "homeopathy for PCOS",
    category: "hormonal",
    remedies: ["Sepia", "Pulsatilla", "Calcarea Carb"],
    whatIs:
      "PCOS is a hormonal-metabolic condition that can affect menstrual regularity, ovulation, skin, weight, and fertility. It is often associated with insulin resistance and inflammation, requiring individualized long-term management and lifestyle correction.",
    symptoms: ["Irregular or delayed periods", "Acne and oily skin", "Excess facial/body hair", "Weight gain and difficulty losing weight", "Mood fluctuation and fatigue"],
    causes: ["Hormonal imbalance and ovulatory dysfunction", "Insulin resistance", "Family history and metabolic tendency", "Stress and sedentary lifestyle", "Sleep disruption and diet pattern"],
    related: ["homeopathy-for-thyroid", "homeopathy-for-anxiety", "homeopathy-for-insomnia"],
  },
  "homeopathy-for-thyroid": {
    slug: "homeopathy-for-thyroid",
    url: "/homeopathy-for-thyroid",
    disease: "Thyroid Disorders",
    keyword: "homeopathy for thyroid",
    category: "hormonal",
    remedies: ["Thyroidinum", "Calcarea Carb", "Lycopodium"],
    whatIs:
      "Thyroid disorders include hypo- and hyperthyroid states that influence metabolism, mood, weight, menstrual function, and energy levels. Proper diagnosis with thyroid profile testing and regular follow-up is important for stable long-term control.",
    symptoms: ["Fatigue, low energy, and brain fog", "Weight gain or unexplained weight loss", "Hair fall and dry skin", "Mood changes and anxiety", "Menstrual irregularity or palpitations"],
    causes: ["Autoimmune thyroid disease", "Iodine and nutritional factors", "Genetic predisposition", "Hormonal transitions", "Stress and immune dysregulation"],
    related: ["homeopathy-for-pcos", "homeopathy-for-hair-fall", "homeopathy-for-anxiety"],
  },
  "homeopathy-for-migraine": {
    slug: "homeopathy-for-migraine",
    url: "/homeopathy-for-migraine",
    disease: "Migraine",
    keyword: "homeopathy for migraine",
    category: "neurological",
    remedies: ["Natrum Mur", "Belladonna", "Sanguinaria"],
    whatIs:
      "Migraine is a recurrent neurovascular headache disorder with moderate to severe throbbing pain, often accompanied by nausea, light sensitivity, and reduced productivity. Trigger recognition and preventive treatment are central to long-term management.",
    symptoms: ["Unilateral throbbing headache", "Nausea, vomiting, and photophobia", "Noise and light sensitivity", "Aura in selected patients", "Post-headache fatigue or dullness"],
    causes: ["Neurovascular hypersensitivity", "Genetic tendency", "Hormonal fluctuations", "Stress, sleep loss, and dehydration", "Dietary and environmental triggers"],
    related: ["homeopathy-for-anxiety", "homeopathy-for-insomnia", "homeopathy-for-sinusitis"],
  },
  "homeopathy-for-anxiety": {
    slug: "homeopathy-for-anxiety",
    url: "/homeopathy-for-anxiety",
    disease: "Anxiety",
    keyword: "homeopathy for anxiety",
    category: "neurological",
    remedies: ["Aconite", "Argentum Nitricum", "Kali Phos"],
    whatIs:
      "Anxiety is a mental and physical stress response that can cause excessive worry, restlessness, palpitations, sleep disturbance, and reduced concentration. Persistent anxiety impacts work, relationships, and physical health and benefits from timely care.",
    symptoms: ["Excessive worrying and overthinking", "Palpitations and restlessness", "Sleep disturbance and irritability", "Digestive discomfort with stress", "Difficulty concentrating"],
    causes: ["Stressful life events", "Neurochemical imbalance", "Family predisposition", "Poor sleep and excessive stimulant intake", "Underlying chronic health concerns"],
    related: ["homeopathy-for-migraine", "homeopathy-for-insomnia", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-insomnia": {
    slug: "homeopathy-for-insomnia",
    url: "/homeopathy-for-insomnia",
    disease: "Insomnia",
    keyword: "homeopathy for insomnia",
    category: "neurological",
    remedies: ["Coffea Cruda", "Passiflora", "Kali Phos"],
    whatIs:
      "Insomnia is difficulty in falling asleep, staying asleep, or waking unrefreshed despite adequate opportunity to sleep. Chronic sleep disturbance affects mood, immunity, metabolism, and cognitive performance and should be managed early.",
    symptoms: ["Delayed sleep onset", "Frequent night awakenings", "Early morning awakening", "Non-restorative sleep", "Daytime fatigue, mood changes, and poor focus"],
    causes: ["Stress and overactive mind", "Screen exposure and poor sleep hygiene", "Anxiety, depression, or pain", "Shift work and circadian rhythm disturbance", "Caffeine or stimulant overuse"],
    related: ["homeopathy-for-anxiety", "homeopathy-for-migraine", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-eczema": {
    url: "/homeopathy-for-eczema",
    keyword: "homeopathy for eczema",
    condition: "Eczema",
    remedies: ["Graphites", "Sulphur", "Petroleum"],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-urticaria", "homeopathy-for-acne"],
  },
  "homeopathy-for-vitiligo": {
    url: "/homeopathy-for-vitiligo",
    keyword: "homeopathy for vitiligo",
    condition: "Vitiligo",
    remedies: ["Arsenicum Sulphuratum Flavum", "Sepia", "Natrum Muriaticum"],
    related: ["homeopathy-for-psoriasis", "homeopathy-for-eczema", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-acne": {
    slug: "homeopathy-for-acne",
    url: "/homeopathy-for-acne",
    disease: "Acne",
    keyword: "homeopathy for acne",
    category: "skin",
    pageTitle: "Homeopathic Treatment for Acne: Understanding Acne & the Scope of Homeopathy in Treating Acne",
    metaDescription: "Learn about acne types, triggers, skincare, and the individualized scope of homeopathy for acne in Noida.",
    whatIs: "Acne develops when hair follicles become blocked with oil (sebum), dead skin cells, and sometimes bacteria. It most commonly affects the face, chest, shoulders, and back because these areas have a higher concentration of oil glands.",
    intro: "Acne is one of the most common skin concerns in teenagers and adults. It is more than “just pimples”: its causes, triggers, severity, and pattern vary from person to person, and persistent acne can affect appearance, confidence, and emotional well-being.",
    symptoms: [
      "Whiteheads and blackheads, which are non-inflammatory lesions",
      "Papules: small, red, tender inflamed bumps",
      "Pustules: inflamed bumps containing visible pus",
      "Deep, larger, and often painful nodules or cystic lesions",
      "Marks or scars following persistent or deeper acne",
    ],
    causes: [
      "Hormonal changes and increased oil production",
      "Family history",
      "Stress and sleep disturbances",
      "Certain cosmetics or skincare products",
      "Dietary factors in some individuals",
      "Environmental influences",
    ],
    additionalSections: [
      {
        id: "types-of-acne",
        heading: "Different Types of Acne",
        paragraphs: ["Understanding the type of acne can help in deciding the most appropriate management plan. Whiteheads remain closed beneath the skin, while blackheads have an open surface that darkens through oxidation rather than dirt. Papules and pustules are inflamed lesions that may require careful management to reduce the risk of marks.", "Nodules and cystic acne are deeper, larger, and often painful lesions beneath the skin. They are more likely to leave scars and should be evaluated by a qualified healthcare professional. Early assessment may help reduce the chances of long-term skin changes."],
      },
      {
        id: "emotional-impact",
        heading: "Acne Is More Than a Skin Problem",
        paragraphs: ["Persistent acne may affect emotional health as well as the skin. It can lead to reduced self-confidence, social hesitation, avoiding photographs or public gatherings, anxiety about appearance, and emotional distress—particularly when marks or scars develop."],
      },
      {
        id: "skincare-tips",
        heading: "General Skincare Tips for People with Acne",
        paragraphs: ["Simple daily habits can support healthy skin, although every person's skin responds differently:"],
        bullets: ["Wash your face gently twice daily.", "Avoid harsh scrubbing.", "Avoid squeezing or picking pimples, which can increase the risk of marks and scarring.", "Maintain regular sleep and hydration.", "Manage stress through healthy routines such as exercise, relaxation techniques, or hobbies."],
      },
      {
        id: "when-to-seek-advice",
        heading: "When Should You Seek Medical Advice?",
        paragraphs: ["Consider consulting a qualified healthcare professional when acne is severe or painful, pimples are leaving scars, breakouts continue despite regular skincare, acne affects confidence or mental well-being, or it begins suddenly with other hormonal symptoms. Early evaluation can help guide appropriate management."],
      },
    ],
    homeopathyHeading: "Homeopathy for Acne: An Individualized Approach",
    homeopathyParagraphs: [
      "In homeopathy, acne is not viewed solely as a skin condition. A detailed case-taking generally considers the type and pattern of acne, age of onset, hormonal influences, family history, sleep, stress, emotional well-being, lifestyle, medical history, and possible individual triggers.",
      "This comprehensive understanding helps the physician individualize the case before deciding on an appropriate homeopathic prescription. Medicines are selected according to the person's overall symptom picture rather than the diagnosis alone, so no single medicine is considered suitable for everyone with acne.",
      "If you are exploring homeopathy for acne, an experienced practitioner can provide an individualized consultation online or offline in Noida. A detailed assessment helps consider both the skin condition and factors that may be contributing to it.",
    ],
    faqs: [
      { q: "What causes acne?", a: "Acne can have several contributing factors, including hormonal changes, family history, oil production, stress, sleep disturbance, cosmetics, dietary factors in some individuals, and environmental influences." },
      { q: "Can picking pimples cause scars?", a: "Squeezing or picking pimples may increase the risk of marks and scarring, so it is best avoided." },
      { q: "When should I consult a doctor for acne?", a: "Seek professional advice for severe or painful acne, scars, persistent breakouts, sudden acne with hormonal symptoms, or acne affecting confidence or mental well-being." },
      { q: "Is homeopathy for acne individualized?", a: "In homeopathic practice, the consultation considers the person's overall symptom pattern and contributing factors rather than selecting one medicine for everyone with acne." },
    ],
    showRemedies: false,
    showTreatmentProcess: false,
    showBenefits: false,
    showImages: false,
    related: ["homeopathy-for-eczema", "homeopathy-for-psoriasis", "homeopathy-for-dandruff"],
  },
  "homeopathy-for-urticaria": {
    url: "/homeopathy-for-urticaria",
    keyword: "homeopathy for urticaria",
    condition: "Urticaria",
    remedies: ["Apis Mellifica", "Urtica Urens", "Natrum Mur"],
    related: ["homeopathy-for-allergic-rhinitis", "homeopathy-for-eczema", "homeopathy-for-psoriasis"],
  },
  "homeopathy-for-hair-fall": {
    url: "/homeopathy-for-hair-fall",
    keyword: "homeopathy for hair fall",
    condition: "Hair Fall",
    remedies: ["Phosphorus", "Natrum Mur", "Lycopodium"],
    related: ["homeopathy-for-alopecia", "homeopathy-for-dandruff", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-alopecia": {
    url: "/homeopathy-for-alopecia",
    keyword: "homeopathy for alopecia",
    condition: "Alopecia",
    remedies: ["Fluoric Acid", "Natrum Mur", "Silicea"],
    related: ["homeopathy-for-hair-fall", "homeopathy-for-dandruff", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-dandruff": {
    url: "/homeopathy-for-dandruff",
    keyword: "homeopathy for dandruff",
    condition: "Dandruff",
    remedies: ["Kali Sulph", "Natrum Mur", "Sulphur"],
    related: ["homeopathy-for-hair-fall", "homeopathy-for-alopecia", "homeopathy-for-acne"],
  },
  "homeopathy-for-sinusitis": {
    url: "/homeopathy-for-sinusitis",
    keyword: "homeopathy for sinusitis",
    condition: "Sinusitis",
    remedies: ["Kali Bichromicum", "Pulsatilla", "Silicea"],
    related: ["homeopathy-for-allergic-rhinitis", "homeopathy-for-asthma", "homeopathy-for-migraine"],
  },
  "homeopathy-for-allergic-rhinitis": {
    slug: "homeopathy-for-allergic-rhinitis",
    url: "/homeopathy-for-allergic-rhinitis",
    disease: "Allergies",
    keyword: "homeopathy for allergies",
    category: "respiratory",
    pageTitle: "Can Homeopathy Help in Allergies? A Doctor Explains",
    metaDescription: "Understand allergies, recurring symptoms, practical trigger reduction, and the individualized scope of homeopathy for allergies in Noida.",
    whatIs: "An allergy is an exaggerated immune-system response to something that is usually harmless. The trigger, or allergen, may be pollen, house dust mites, pet dander, mould, certain foods, insect stings, or specific medications. In an allergic response, chemicals such as histamine can produce familiar symptoms.",
    intro: "Allergies can interrupt everyday life with repeated sneezing, itchy eyes, a blocked nose, rashes, or wheezing. Symptoms and triggers differ widely between people, so understanding the condition and identifying individual triggers are important first steps toward better control.",
    symptoms: [
      "Repeated sneezing, especially in the morning",
      "A blocked or runny nose",
      "Itchy eyes, nose, or throat and watery eyes",
      "Frequent throat irritation or recurrent sinus congestion",
      "Skin rashes or itching",
      "Wheezing episodes in some individuals",
    ],
    causes: [
      "Repeated exposure to dust, pollen, mould, smoke, pollution, or pet dander",
      "Multiple triggers rather than a single allergen",
      "Family tendency in some people",
      "Coexisting conditions such as chronic sinus disease or asthma",
    ],
    additionalSections: [
      {
        id: "why-allergies-return",
        heading: "Why Do Allergies Keep Coming Back?",
        paragraphs: ["Recurrence is frustrating, but there is rarely a single explanation. The allergen may still be present in the environment, a person may be repeatedly exposed to dust, pollen, mould, smoke, pollution, or pet dander, or multiple triggers may be involved. Chronic sinus disease or asthma can also coexist with allergies and contribute to ongoing symptoms."],
      },
      {
        id: "allergy-or-cold",
        heading: "Is Every Runny Nose an Allergy?",
        paragraphs: ["No. Common colds, viral infections, sinusitis, and allergies can produce similar symptoms. Allergies often cause repeated sneezing, itching, and clear nasal discharge without fever. Viral infections may include fever and body aches, while sinusitis can cause facial pain, thick discharge, and pressure around the eyes. Self-diagnosis is not always reliable."],
      },
      {
        id: "permanent-cure",
        heading: "Can Allergies Be Cured Permanently?",
        paragraphs: ["The answer depends on the type of allergy, the trigger involved, overall health, and response to treatment. For many people, the goal is to reduce the frequency and severity of episodes, improve quality of life, and minimise disruption to daily activities. No treatment system can honestly promise that every allergy will disappear permanently in every individual."],
      },
      {
        id: "practical-steps",
        heading: "Practical Steps That Can Help Reduce Allergies",
        paragraphs: ["Alongside appropriate medical treatment, practical measures may help. Not every suggestion applies to everyone, so understanding personal triggers remains important."],
        bullets: ["Keep bedrooms as dust-free as possible.", "Wash bedding regularly in hot water if dust mite allergy is suspected.", "Use masks while cleaning dusty areas.", "Avoid cigarette smoke.", "Keep windows closed during high-pollen periods if pollen is a known trigger.", "Avoid specific food triggers only when they have been confirmed.", "Stay well hydrated and maintain overall good health."],
      },
      {
        id: "allergy-myths",
        heading: "Common Myths About Allergies",
        paragraphs: ["Myth: Allergies only occur during spring. Fact: Seasonal allergies are common, but dust mites, mould, and pet dander can cause year-round symptoms.", "Myth: Every sneeze means you have an allergy. Fact: Viral infections, pollution, temperature changes, and strong fragrances can also cause sneezing.", "Myth: Allergies are always inherited. Fact: Family history may increase the likelihood, but it is not determinative; people without a family history can also have allergies."],
      },
      {
        id: "when-to-consult",
        heading: "When Should You Consult a Doctor?",
        paragraphs: ["Seek medical advice when symptoms keep returning despite treatment, nasal blockage interferes with sleep, sinus infections recur, allergies affect school, work, or daily activities, wheezing or breathing difficulty occurs, or symptoms are progressively worsening. Proper evaluation can distinguish allergies from conditions that need different treatment."],
      },
    ],
    homeopathyHeading: "Where Can Homeopathy Fit In?",
    homeopathyParagraphs: [
      "Homeopathy is based on an individualized approach. A homeopathic consultation typically considers the complete symptom pattern, medical history, general health, and individual characteristics before selecting a medicine. Two people with allergic rhinitis may therefore not receive the same prescription.",
      "Some people choose to explore homeopathy as part of an overall approach to recurrent allergic conditions. Outcomes vary from person to person, and treatment should be guided by a qualified healthcare professional.",
      "Homeopathy must not replace emergency treatment for severe allergic reactions such as anaphylaxis. Sudden breathing difficulty, swelling of the tongue or throat, collapse, or a severe reaction after an insect sting or food exposure requires immediate emergency medical care.",
    ],
    faqs: [
      { q: "Can allergies occur all year round?", a: "Yes. Although some allergies are seasonal, dust mites, mould, and pet dander can cause year-round symptoms." },
      { q: "Does every sneeze mean I have an allergy?", a: "No. Viral infections, pollution, temperature changes, and strong fragrances can also cause sneezing." },
      { q: "Can allergies be permanently cured?", a: "Long-term outcomes vary. The aim is often to reduce episode frequency and severity, improve quality of life, and minimise disruption." },
      { q: "When is an allergic reaction an emergency?", a: "Sudden breathing difficulty, swelling of the tongue or throat, collapse, or a severe reaction after food or an insect sting requires immediate emergency medical care." },
    ],
    showRemedies: false,
    showTreatmentProcess: false,
    showBenefits: false,
    showImages: false,
    related: ["homeopathy-for-sinusitis", "homeopathy-for-asthma", "homeopathy-for-urticaria"],
  },
  "homeopathy-for-asthma": {
    url: "/homeopathy-for-asthma",
    keyword: "homeopathy for asthma",
    condition: "Asthma",
    remedies: ["Arsenicum Album", "Spongia Tosta", "Ipecacuanha"],
    related: ["homeopathy-for-allergic-rhinitis", "homeopathy-for-sinusitis", "homeopathy-for-anxiety"],
  },
  "homeopathy-for-pcos": {
    url: "/homeopathy-for-pcos",
    keyword: "homeopathy for PCOS",
    condition: "PCOS",
    remedies: ["Sepia", "Pulsatilla", "Calcarea Carb"],
    related: ["homeopathy-for-thyroid", "homeopathy-for-anxiety", "homeopathy-for-insomnia"],
  },
  "homeopathy-for-thyroid": {
    url: "/homeopathy-for-thyroid",
    keyword: "homeopathy for thyroid",
    condition: "Thyroid Disorders",
    remedies: ["Thyroidinum", "Calcarea Carb", "Lycopodium"],
    related: ["homeopathy-for-pcos", "homeopathy-for-hair-fall", "homeopathy-for-anxiety"],
  },
  "homeopathy-for-migraine": {
    url: "/homeopathy-for-migraine",
    keyword: "homeopathy for migraine",
    condition: "Migraine",
    remedies: ["Natrum Mur", "Belladonna", "Sanguinaria"],
    related: ["homeopathy-for-sinusitis", "homeopathy-for-anxiety", "homeopathy-for-insomnia"],
  },
  "homeopathy-for-anxiety": {
    url: "/homeopathy-for-anxiety",
    keyword: "homeopathy for anxiety",
    condition: "Anxiety",
    remedies: ["Aconite", "Argentum Nitricum", "Kali Phos"],
    related: ["homeopathy-for-insomnia", "homeopathy-for-migraine", "homeopathy-for-thyroid"],
  },
  "homeopathy-for-enlarged-adenoids": {
    slug: "homeopathy-for-enlarged-adenoids",
    url: "/homeopathy-for-enlarged-adenoids",
    disease: "Enlarged Adenoids",
    keyword: "homeopathy for enlarged adenoids",
    category: "respiratory",
    pageTitle: "Can Homeopathy Help in Enlarged Adenoids? A Doctor Explains",
    metaDescription: "Learn about enlarged adenoids in children, including snoring, diagnosis, surgery decisions, homeopathy, and when to seek ENT assessment.",
    whatIs: "Adenoids are a small collection of immune tissue behind the nose. During childhood they help the immune system recognise germs entering through the nose and mouth, so they are often active as children encounter new viruses and bacteria.",
    intro: "Enlarged adenoids are a common reason children develop persistent nasal blockage, snoring, and recurrent respiratory infections. Not every child with enlarged adenoids needs surgery; the important question is how they affect breathing, sleep, hearing, and daily life.",
    symptoms: [
      "Persistent nasal blockage and mouth breathing",
      "Loud snoring, restless sleep, or frequent waking",
      "A nasal quality to the voice",
      "Recurrent colds or ear infections",
      "Difficulty hearing due to fluid in the middle ear",
      "Daytime irritability or tiredness after poor-quality sleep",
    ],
    causes: [
      "Temporary swelling during or after an infection",
      "Repeated infections or ongoing inflammation",
      "Allergies that contribute to nasal blockage",
      "Enlarged tonsils, nasal blockage, or other causes of snoring",
    ],
    homeopathyHeading: "Where Can Homeopathy Fit In?",
    homeopathyParagraphs: [
      "Many parents ask whether homeopathy has a role when a child has enlarged adenoids. In clinical homeopathic practice, treatment is typically individualised: the consultation considers the child's overall symptom pattern, frequency of infections, general health, sleep, temperament, and medical history before a prescription is considered.",
      "Some families choose to explore homeopathy as part of their child's overall care, particularly when looking for a personalised approach to recurrent upper-respiratory complaints. Response can vary from child to child.",
      "Significant breathing difficulty during sleep, persistent hearing problems, recurrent ear infections, or other complications need proper medical assessment and should not be delayed while trying alternative approaches.",
    ],
    additionalSections: [
      {
        id: "snoring-causes",
        heading: "Is Snoring Always Due to Adenoids?",
        paragraphs: ["No. Children may snore for several reasons, including enlarged adenoids or tonsils, allergies, nasal blockage, a deviated nasal septum (less commonly in young children), or obesity in older children. Proper evaluation is important rather than assuming the cause."],
      },
      {
        id: "sleep-and-behaviour",
        heading: "Can Enlarged Adenoids Affect Growth or Behaviour?",
        paragraphs: ["Poor sleep can affect much more than the night. A child who does not sleep well may be more irritable, less attentive at school, tired during the day, less interested in eating, or more prone to behavioural difficulties. These signs do not always mean adenoids are responsible, but persistent snoring should not be ignored."],
      },
      {
        id: "diagnosis",
        heading: "How Are Enlarged Adenoids Diagnosed?",
        paragraphs: ["Diagnosis usually includes a detailed history and examination by a doctor. Depending on the clinical situation, a nasal endoscopy, X-ray, or other investigation may be considered. The goal is not simply to measure adenoid size, but to understand the effect on breathing, sleep, and daily life."],
      },
      {
        id: "surgery",
        heading: "Will My Child Definitely Need Surgery?",
        paragraphs: ["Not necessarily. The decision depends on symptom severity, nasal obstruction, sleep disturbance, recurrent ear infections, hearing problems, response to medical treatment, and overall quality of life. Some children improve as they grow because adenoids tend to shrink with age, while others need surgery when symptoms are significant or complications develop. An ENT specialist can advise whether surgery is appropriate."],
      },
      {
        id: "at-home-care",
        heading: "What Can Parents Do at Home?",
        paragraphs: ["Treatment depends on the individual child, but general measures can support respiratory health:"],
        bullets: ["Encourage regular hand washing.", "Ensure adequate sleep.", "Offer a balanced diet appropriate for your child's age.", "Reduce exposure to cigarette smoke.", "Manage allergies if present.", "Keep advised ENT follow-up appointments."],
      },
    ],
    faqs: [
      { q: "Will enlarged adenoids disappear on their own?", a: "Sometimes they become smaller as children grow older, but not every child improves in the same way." },
      { q: "Can enlarged adenoids come back after surgery?", a: "In some cases, a small amount of adenoid tissue may remain or regrow, although this is uncommon." },
      { q: "Does every child who snores have enlarged adenoids?", a: "No. Snoring has several possible causes, which is why evaluation is important." },
      { q: "Can allergies make adenoid symptoms worse?", a: "Yes. Ongoing nasal allergies may contribute to nasal blockage and can make symptoms seem more troublesome." },
    ],
    showRemedies: false,
    showTreatmentProcess: false,
    showBenefits: false,
    showImages: false,
    related: ["homeopathy-for-allergic-rhinitis", "homeopathy-for-sinusitis", "homeopathy-for-asthma"],
  },
  "piles-fissure-or-fistula": {
    slug: "piles-fissure-or-fistula",
    url: "/piles-fissure-or-fistula",
    disease: "Piles, Fissure & Fistula",
    keyword: "piles fissure fistula treatment",
    category: "digestive",
    pageTitle: "Piles, Fissure or Fistula? Understanding the Difference and the Role of Homeopathy",
    metaDescription: "Learn the difference between piles, anal fissure, and fistula, their common symptoms, warning signs, and when medical or surgical assessment is needed.",
    whatIs: "Piles, fissures, and fistulas all affect the anal region, but they are three different conditions with different causes, symptoms, and treatment approaches. Understanding the difference is the first step towards getting the right treatment.",
    intro: "Pain while passing stools can be worrying, especially when different people use the words piles, fissure, and fistula interchangeably. A proper examination is important because the same symptom can have more than one cause.",
    symptoms: [
      "Bright red bleeding, swelling, itching, mucus discharge, or incomplete evacuation with piles",
      "Sharp pain during or after a bowel movement with an anal fissure",
      "Recurrent swelling, pus discharge, persistent pain, irritation, or repeated boils with an anal fistula",
      "Symptoms that do not fit one simple pattern and need a proper clinical examination",
    ],
    causes: [
      "Frequent constipation and excessive straining during bowel movements",
      "A low-fibre diet, inadequate water intake, prolonged sitting, or delaying the urge to pass stools",
      "Pregnancy, obesity, inflammatory bowel disease, infections, and certain medical conditions",
      "Hard stools, repeated diarrhoea, childbirth, or an infection or abscess around the anus",
    ],
    additionalSections: [
      {
        id: "why-common",
        heading: "Why Are These Conditions So Common Today?",
        paragraphs: [
          "Long hours of sitting, lack of exercise, inadequate water intake, processed foods, stress, irregular meal timings, and ignoring the urge to pass stools can all contribute to bowel problems.",
          "When constipation becomes frequent, excessive straining during bowel movements increases pressure on the anal region. Over time, this can contribute to several anorectal conditions. Constipation is not the only cause: pregnancy, obesity, inflammatory bowel diseases, infections, and certain medical conditions may also play a role.",
        ],
      },
      {
        id: "what-are-piles",
        heading: "What Are Piles?",
        paragraphs: [
          "Piles, also called haemorrhoids, are swollen veins in or around the rectum and anus. They can be thought of as somewhat similar to varicose veins, except that they occur in the anal canal.",
          "Not everyone with piles experiences pain. Many people first notice bright red bleeding during bowel movements, a small swelling around the anus, itching, mucus discharge, or a feeling that the bowel has not emptied completely. Pain usually develops when a pile becomes thrombosed or prolapses significantly.",
        ],
      },
      {
        id: "what-is-fissure",
        heading: "What Is an Anal Fissure?",
        paragraphs: [
          "A fissure is not a swelling. It is a small tear in the lining of the anal canal. Many patients describe the pain as feeling like passing broken glass, and the sharp pain may continue for several minutes—or even hours—after passing stools.",
          "A fissure often develops after passing a very hard stool, severe constipation, repeated diarrhoea, or childbirth in some women. Because passing stools becomes painful, people may avoid going to the toilet, which makes constipation worse and creates a vicious cycle.",
        ],
      },
      {
        id: "what-is-fistula",
        heading: "What Is a Fistula?",
        paragraphs: [
          "A fistula is completely different from both piles and fissures. It is an abnormal tunnel between the anal canal and the skin around the anus, usually after an infection or abscess.",
          "Symptoms can include recurrent swelling, pus discharge, persistent pain, irritation around the anus, or repeated boils near the anal opening. Unlike piles or fissures, fistulas usually do not heal on their own and often require evaluation by a colorectal surgeon.",
        ],
      },
      {
        id: "telling-the-difference",
        heading: "How Can You Tell the Difference?",
        paragraphs: ["A simple way to remember is: piles usually cause bleeding, fissures usually cause severe pain, and fistulas usually cause recurrent discharge. Not every patient fits these patterns perfectly, which is why a proper examination matters."],
      },
      {
        id: "rectal-bleeding",
        heading: "Don't Ignore Rectal Bleeding",
        paragraphs: ["One of the biggest mistakes people make is assuming that every episode of bleeding is just piles. While piles are a common cause, similar symptoms can occur with inflammatory bowel disease, polyps, infections, and, less commonly, cancers of the bowel. Persistent bleeding should never be self-treated without medical evaluation."],
      },
      {
        id: "recurrence",
        heading: "Why Do These Problems Keep Coming Back?",
        paragraphs: ["Symptoms may recur when the underlying habits remain unchanged. Common contributors include chronic constipation, a low-fibre diet, inadequate water intake, long hours of sitting, delaying bowel movements, lack of physical activity, obesity, pregnancy, and stress-related bowel disturbances. Treating symptoms without addressing these factors can lead to recurrence."],
      },
      {
        id: "simple-measures",
        heading: "Simple Measures That Can Make a Big Difference",
        paragraphs: ["Whether you are undergoing treatment or trying to prevent recurrence, consistent everyday habits matter."],
        bullets: ["Drink adequate water throughout the day.", "Include fibre-rich foods such as fruits, vegetables, whole grains, and salads.", "Avoid prolonged sitting on the toilet.", "Do not ignore the natural urge to pass stools.", "Stay physically active.", "Avoid excessive straining during bowel movements.", "Manage constipation early rather than waiting for it to become chronic."],
      },
      {
        id: "final-thought",
        heading: "A Final Thought",
        paragraphs: ["People often delay seeking help because they feel embarrassed discussing problems related to the anal region. Delaying evaluation can sometimes allow a simple problem to become more complicated.", "Most anorectal conditions can be managed effectively when diagnosed early. Whether symptoms are due to piles, a fissure, or a fistula, the first step is an accurate diagnosis. Once the cause is clear, the most appropriate medical, homeopathic, surgical, or combined plan can be discussed."],
      },
    ],
    homeopathyHeading: "Can Homeopathy Help?",
    homeopathyParagraphs: [
      "Many people explore homeopathy as a non-surgical option, particularly in the early stages of piles or fissure, or when symptoms recur despite temporary relief. In homeopathic practice, the consultation considers the complete picture: bowel habits, nature of pain, constipation or diarrhoea tendency, diet, sleep, stress, work routine, emotional health, and other contributing factors.",
      "The aim is not simply to reduce local symptoms but to understand why the problem developed and what may contribute to repeated episodes. Some patients report improvement in pain, bleeding, itching, constipation, or discomfort during treatment, but response varies and the appropriate treatment depends on the stage and severity of disease.",
      "Advanced fistulas, severe bleeding, strangulated piles, large prolapsing haemorrhoids, or complications may require surgical assessment. Homeopathy should not delay timely referral where surgery or emergency treatment is clearly indicated.",
      "In advanced or complicated cases, surgery may be the most appropriate way to address the immediate problem. Long-term care should also address contributing factors such as chronic constipation, bowel habits, diet, lifestyle, stress, and other individual health concerns. This is based on an individual medical assessment and does not replace surgical care when surgery is indicated.",
    ],
    faqs: [
      { q: "Can piles turn into cancer?", a: "No. Piles themselves do not become cancer. However, rectal bleeding can have several causes, so it should not automatically be assumed to be piles." },
      { q: "Is every painful bowel movement a fissure?", a: "No. Pain can occur due to fissures, thrombosed piles, infections, and several other conditions." },
      { q: "Can constipation alone cause piles?", a: "Constipation is a major contributing factor, but pregnancy, obesity, prolonged sitting, and family history may also increase the risk." },
      { q: "Can these conditions be prevented?", a: "Many cases can be reduced by maintaining healthy bowel habits, staying hydrated, eating a fibre-rich diet, and remaining physically active." },
    ],
    showRemedies: false,
    showTreatmentProcess: false,
    showBenefits: false,
    showImages: false,
    related: [],
  },

};

const normalizeTreatmentPages = (pages) => {
  const slugs = new Set(Object.keys(pages));

  return Object.fromEntries(
    Object.entries(pages).map(([slug, page]) => {
      const related = (page.related || [])
        .filter((relatedSlug) => relatedSlug !== slug && slugs.has(relatedSlug))
        .slice(0, 4);

      const disease = page.disease || page.condition || "Condition";
      const keyword = page.keyword || `homeopathy for ${disease.toLowerCase()}`;

      return [
        slug,
        {
          ...page,
          slug: page.slug || slug,
          url: page.url || `/${slug}`,
          disease,
          keyword,
          category: page.category || "general",
          remedies: page.remedies || [],
          symptoms: page.symptoms || [],
          causes: page.causes || [],
          related,
        },
      ];
    })
  );
};

const normalizedTreatmentPages = normalizeTreatmentPages(treatmentPages);

export default normalizedTreatmentPages;
